// extracted by mini-css-extract-plugin
export default {"adExpiration":"_1_UU8"};